module.exports = __webpack_public_path__ + "img/declined.881a756d.svg";